<!--<v-dialog  class="pa-0 display-unset" v-model="dialog" width="700">-->
<template>
    <v-container fluid grid-list-md class="pt-0">
      <v-layout row wrap align-center>
        <v-flex class="text-xs-center" xs12 lg12>
          <v-card class="white no-shadow pa-3 card-r grey lighten-4">
            <v-toolbar class="tow-clor-1 card-r mb-2 shadow-1 pl-3 text-white">
              <v-btn flat :to="'/teacherprofile/'+teacherId+'#calender'" icon class="card-r">
                <v-icon class="text-white left">keyboard_arrow_left</v-icon>
              </v-btn>
              <div class="text-xs-left f-17 text-capitalize">Create Event</div>
              <v-spacer></v-spacer>

            </v-toolbar>
            <v-flex xs12 lg12 class="text-xs-center pa-2" v-if="alertType">
               <v-alert
                  :value="true"
                  :type="alertType"
                >
                  {{msg}}
                </v-alert>
            </v-flex>
            <v-layout row wrap class="pl-1">
              <div class="f-15 pl-2 w-100 text-xs-left text-primary font-weight-bold">Select Date</div>
              <v-flex lg12 xs12>
                <HotelDatePicker
                @check-in-changed="checkInChanged($event)"
                @check-out-changed="checkOutChanged($event)">
                format="DD/MM/YYYY">
                </HotelDatePicker>
              </v-flex>
            </v-layout>
            <v-flex lg4 xs12 class="">
              <div class="f-15 pl-1 w-100 text-xs-left text-primary font-weight-bold">whats is your plan</div>
              <v-autocomplete solo
                    v-model="event.selectedPlan"
                    prepend-icon="alarm"
                    :items=items
                    class=""
                    label="whats is your plan"
                    placeholder="select your plan">
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 lg12 class="text-xs-right pa-2" v-if="!loading">
              <v-btn @click="submitEvent" class="text-white card-r text-xs-right" color="primary darken-2">Create Event</v-btn>
            </v-flex>
            <v-flex xs12 lg12 class="text-xs-center pa-2" v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-flex>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
  /* eslint-disable */
  import HotelDatePicker from 'vue-hotel-datepicker'
  import api from "@/utils/backend-api"
  export default {
    props:['id'],
    data () {
      return {
        model: false,
        teacherId:'',
        items:['sick','holiday','vacation','leave'],
        loading:false,
        event:{
          start_date:'',
          end_date:'',
          selectedPlan:''
        },

      }
    },
    created:function(){
      this.teacherId=this.$route.params.id
    },
    methods:{
      checkInChanged(date){
        this.event.start_date=this.convertDate(date)
      },
      checkOutChanged(date){
        this.event.end_date=this.convertDate(date)
      },
      convertDate(date){
        var date = new Date(date),
        mnth = ("0" + (date.getMonth()+1)).slice(-2),
        day  = ("0" + date.getDate()).slice(-2);
        return [ date.getFullYear(), mnth, day ].join("-");
      },
      submitEvent() {
        this.loading=true
        this.alertType=''
        this.msg=''

        let Data={
          title:this.event.selectedPlan,
          start_date:this.event.start_date,
          end_date:this.event.end_date,
          teacher_id:this.teacherId
        }
        api.postData('admin/adminCreateEvent',Data)
        .then(res=>{
          if(res.status==200){
            console.log(res)
            this.loading=false
            this.alertType='success'
            this.msg='successfully Created'
            setTimeout(()=>{
                this.alertType=''
                this.msg=''
            },6000);
          }else{
            this.loading=false
            this.alertType="error"
            this.msg="Event failed to create. Please check your values"
          }
        }).catch(error=>{
            this.loading=false
            console.log(error.response)
            this.alertType="error"
            this.msg="Event failed to create"
        })
          // Store.dispatch('storeTeacherEvents', {'datas':this.datas1, 'teacher':this.$route.params.id});
          // const vm = this;
          // vm.events.push({
          //     title: vm.datas1.title ? vm.datas1.title : 'Sample Event',
          //     start: vm.datas1.start_date,
          //     end: vm.datas1.end_date,
          //     cssClass: vm.selectedEventClass ? vm.selectedEventClass : null
          // });
          // vm.createEventDate = null;
          // vm.newEventTitle = '';
          // vm.dialogCreateEvent = false;
          // this.datas1 = '';
      }
    },
    components: {
      HotelDatePicker,
    },
  }
</script>
<style>
  .datepicker__input {
    -webkit-appearance: none !important;
  }
  .datepicker__close-button {
    top: 10px!important;
    font-weight: unset!important;
    font-size: 30px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/test/CreateEvent.vue